import Pusher from 'pusher-js';

import config from './config/env';

// Pusher.logToConsole = config.isDevelopment;
/**
 * The Pusher application key retrieved from the environment configuration.
 * @constant {string}
 */
const pusher_key = config.pusher.key;
const pusher_cluster = config.pusher.cluster;

/**
 * A configured instance of the Pusher client.
 * This service is used to subscribe to channels and listen for events.
 *
 * Current usage in the project:
 * 1. Real-time Deployment Notifications: Subscribes to environment-specific channels ('local', 'dev', 'prod')
 *    to listen for 'deployment' events, allowing the app to handle updates (e.g., setting 'FORCE_RELOAD').
 * 2. Force Logout (Potential/Legacy): Code exists (currently commented out) to handle 'force_logout' events
 *    for remotely logging out specific users.
 *
 * @type {Pusher}
 */
const PusherService = new Pusher(pusher_key, {
  cluster: pusher_cluster,
  encrypted: true,
});

export default PusherService;
